<template>
	<div v-if="isMakeForm"
		 :class="['tpf-mf-item', {'tpf-mf-item__active': data.makeStyle.active}]">
		<div class="tpf-mf-item--mask"
			 v-if="showMask"></div>
		<div class="tpf-mf-item--op"
			 v-show="data.makeStyle.active">
			<span class="tpf-mf-item--op--copy"
				  @click="copy"><i class="el-icon-document-copy"></i></span>
			<span class="tpf-mf-item--op--delete"
				  @click="del"><i class="el-icon-delete"></i></span>
		</div>
		<el-form-item :label="formData.formStyle.hideLabel || data.style.hideLabel ? '' : data.label"
					  :label-width="formData.formStyle.hideLabel || data.style.hideLabel ? '0' : ''"
					  :class="{'required': required && formData.formStyle.showRequiredAsterisk}">
			<slot></slot>
		</el-form-item>
	</div>
	<el-form-item v-else
				  :label="label"
				  :label-width="labelWidth"
				  :prop="prop"
				  :class="{'required': required && formData.formStyle.showRequiredAsterisk}">
		<slot></slot>
	</el-form-item>
</template>

<script>
import _ from 'lodash'
import { isHaveKey } from '../../utils/tool'
import * as ruleApi from './el-rule'
import { load } from 'mime';

export default {
	name: 'ItemBox',
	inject: ['formData'],
	props: {
		data: {
			type: Object,
			required: true
		},
		isMakeForm: {
			type: Boolean,
			default: true
		},
		prop: String,
		showMask: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			rules: {
				email: [
					// 邮箱
					{
						required: true,
						message: '请输入正确的邮箱地址',
						trigger: 'blur',
						type: 'email'
					}
				],
				idCard: [
					// 身份证
					{
						required: true,
						validator: ruleApi.idCardValidator,
						message: '',
						trigger: 'blur'
					}
				],
				phone: [
					// 电话-座机 格式0551-65604243
					{
						required: true,
						validator: ruleApi.phoneValidator,
						message: '',
						trigger: 'blur'
					}
				],
				mobilePhone: [
					// 电话-手机
					{
						required: true,
						validator: ruleApi.mobilePhoneValidator,
						message: '',
						trigger: 'blur'
					}
				],
				number: [
					// 数字
					{
						required: true,
						validator: ruleApi.numberPhoneValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				chinese: [
					// 中文
					{
						required: true,
						validator: ruleApi.chineseValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				english: [
					// 英文
					{
						required: true,
						validator: ruleApi.englishValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				url: [
					// url
					{
						required: true,
						validator: ruleApi.urlValidator,
						message: '',
						trigger: 'blur'
					}
				],
				upper: [
					// 大写
					{
						required: true,
						validator: ruleApi.upperValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				lower: [
					// 小写
					{
						required: true,
						validator: ruleApi.lowerValidator,
						message: '',
						trigger: ['blur', 'change']
					}
				],
				pwd: [
					// 密码以字母开头，长度在6~18之间，只能包含字母、数字和下划线
					{
						required: true,
						validator: ruleApi.pwdValidator,
						message: '',
						trigger: 'blur'
					}
				],
				postal: [
					// 邮政编码
					{
						required: true,
						validator: ruleApi.postalValidator,
						message: '',
						trigger: 'blur'
					}
				],
				minMax: [
					// 数字区间
					{
						required: true,
						validator: ruleApi.minMaxValidator,
						message: '',
						trigger: 'blur',
						min: 0,
						max: 0
					}
				],
				length: [
					// 字符长度
					{
						required: true,
						validator: ruleApi.lengthValidator,
						message: '',
						trigger: 'blur',
						length: 0
					}
				]
			},
			rule: {}
		}
	},
	computed: {
		required() {
			return (
				Reflect.has(this.data, 'rules') &&
				Reflect.has(this.data.rules, 'required')
			)
		},

		label() {
			if (!isHaveKey(this.data.style, 'hideLabel') ) return this.data.label
			if (this.formData.formStyle.hideLabel || this.data.style.hideLabel ) return ''
			return this.data.label
		},

		labelWidth() {
			if (!isHaveKey(this.data.style, 'hideLabel') ) return ''
			if (this.formData.formStyle.hideLabel || this.data.style.hideLabel ) return '0'
			return ''
		}
	},
	methods: {
		copy() {
			const data = _.cloneDeep(this.data)
			data.fieldId = `${data.field}`
			const i = this.formData.formDataList.findIndex(
				li => li === this.data
			)
			if (i > -1) this.formData.formDataList.splice(i, 0, data)
			else {
				const allColList = this.formData.formDataList.filter(
					li => li.name === 'Layout'
				)
				for (let x = 0; x < allColList.length; x++) {
					const j = allColList[x].setting.colList.findIndex(
						c => c === this.data
					)
					if (j > -1) allColList[x].setting.colList.splice(j, 0, data)
				}
			}
			// this.formData.model[data.fieldId] = data.value;
			// this.$set(this.formData.model, data.fieldId, data.value);
		},

		del() {
			const i = this.formData.formDataList.findIndex(
				li => li === this.data
			)
			if (i > -1) this.formData.formDataList.splice(i, 1)
			else {
				const allColList = this.formData.formDataList.filter(
					li => li.name === 'Layout'
				)
				for (let x = 0; x < allColList.length; x++) {
					const j = allColList[x].setting.colList.findIndex(
						c => c === this.data
					)
					if (j > -1) allColList[x].setting.colList.splice(j, 1)
				}
			}
		}
	}
}
</script>